import React, { useState } from 'react';
import { LayoutDashboard, Heart, MessageSquare, Settings, Search, MapPin, Clock, ArrowRight } from 'lucide-react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Link } from 'react-router-dom';
import { ScheduleVisitModal } from '../components/modals/ScheduleVisitModal';
import { MessageModal } from '../components/modals/MessageModal';
export function BuyerDashboardPage() {
  const [isVisitModalOpen, setIsVisitModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: ''
  });
  const [selectedPlot, setSelectedPlot] = useState<{
    title: string;
    location: string;
  } | null>(null);
  const handleScheduleVisit = (title: string, location: string) => {
    setSelectedPlot({
      title,
      location
    });
    setIsVisitModalOpen(true);
  };
  const handleEditPreferences = () => {
    setModalContent({
      title: 'Edit Search Preferences',
      message: 'Search preference editing is coming soon. You will be able to set location preferences, budget ranges, plot size preferences, and receive personalized recommendations.'
    });
    setIsMessageModalOpen(true);
  };
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard'
  }, {
    label: 'Shortlisted Plots',
    icon: Heart,
    path: '/buyer/shortlisted'
  }, {
    label: 'My Inquiries',
    icon: MessageSquare,
    path: '/buyer/inquiries'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/buyer/settings'
  }];
  return <DashboardLayout title="My Dashboard" personaLabel="BUYER" personaColor="bg-green-100 text-green-800 border-green-200" navItems={navItems} userInitials="JD" data-id="element-3153">
      <div data-testid="buyer-dashboard-page" className="space-y-8" data-id="element-3154">
        <div data-testid="buyer-dashboard-header" className="mb-8" data-id="element-3155">
          <h1 data-testid="buyer-dashboard-title" className="text-2xl font-bold mb-2" data-id="element-3156">
            Welcome back, John
          </h1>
          <p data-testid="buyer-dashboard-subtitle" className="text-gray-500 font-mono text-sm" data-id="element-3157">
            Here's what's happening with your plot search.
          </p>
        </div>

        <div data-testid="buyer-dashboard-stats" className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-3158">
          <Link data-testid="buyer-dashboard-shortlisted-card" to="/buyer/shortlisted" className="bg-white border border-gray-300 p-6 hover:shadow-md transition-shadow group" data-id="element-3159">
            <div className="flex justify-between items-start mb-4" data-id="element-3160">
              <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-3161">
                Shortlisted
              </h3>
              <Heart className="w-5 h-5 text-gray-400 group-hover:text-red-500 transition-colors" data-id="element-3162" />
            </div>
            <div data-testid="buyer-dashboard-shortlisted-count" className="text-3xl font-bold mb-1" data-id="element-3163">
              12
            </div>
            <div className="text-xs text-gray-500" data-id="element-3164">3 price drops this week</div>
          </Link>

          <Link data-testid="buyer-dashboard-inquiries-card" to="/buyer/inquiries" className="bg-white border border-gray-300 p-6 hover:shadow-md transition-shadow group" data-id="element-3165">
            <div className="flex justify-between items-start mb-4" data-id="element-3166">
              <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-3167">
                Active Inquiries
              </h3>
              <MessageSquare className="w-5 h-5 text-gray-400 group-hover:text-blue-500 transition-colors" data-id="element-3168" />
            </div>
            <div data-testid="buyer-dashboard-inquiries-count" className="text-3xl font-bold mb-1" data-id="element-3169">
              5
            </div>
            <div className="text-xs text-gray-500" data-id="element-3170">2 new replies</div>
          </Link>

          <div data-testid="buyer-dashboard-searches-card" className="bg-white border border-gray-300 p-6" data-id="element-3171">
            <div className="flex justify-between items-start mb-4" data-id="element-3172">
              <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-3173">
                Recent Searches
              </h3>
              <Search className="w-5 h-5 text-gray-400" data-id="element-3174" />
            </div>
            <div className="space-y-2" data-id="element-3175">
              <div className="text-sm font-bold flex items-center gap-2" data-id="element-3176">
                <MapPin className="w-3 h-3 text-gray-400" data-id="element-3177" /> Hinjewadi, Pune
              </div>
              <div className="text-sm font-bold flex items-center gap-2" data-id="element-3178">
                <MapPin className="w-3 h-3 text-gray-400" data-id="element-3179" /> Whitefield, Blr
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-3180">
          <div data-testid="buyer-dashboard-activity" className="bg-white border border-gray-300 p-6" data-id="element-3181">
            <div className="flex justify-between items-center mb-6" data-id="element-3182">
              <h3 className="font-bold text-lg" data-id="element-3183">Recent Activity</h3>
              <Link to="/buyer/inquiries" className="text-xs font-bold text-[#1f2933] hover:underline" data-id="element-3184">
                View All
              </Link>
            </div>
            <div className="space-y-4" data-id="element-3185">
              {[{
              type: 'Reply Received',
              plot: 'Green Valley Plot A-101',
              time: '2 hours ago',
              action: 'View Reply',
              link: '/buyer/inquiries/1'
            }, {
              type: 'Price Drop',
              plot: 'Corner Plot in Baner',
              time: 'Yesterday',
              action: 'View Plot',
              link: '/listing/1'
            }, {
              type: 'Document Verified',
              plot: 'Sunrise Heights B-202',
              time: '2 days ago',
              action: 'Check Docs',
              link: '/listing/1#documents'
            }].map((item, i) => <div key={i} data-testid={`buyer-dashboard-activity-item-${i + 1}`} className="flex items-center justify-between p-3 bg-gray-50 border border-gray-200" data-id="element-3186">
                  <div data-id="element-3187">
                    <div className="text-xs font-bold text-blue-600 mb-1" data-id="element-3188">
                      {item.type}
                    </div>
                    <div className="font-bold text-sm" data-id="element-3189">{item.plot}</div>
                    <div className="text-xs text-gray-500 flex items-center gap-1 mt-1" data-id="element-3190">
                      <Clock className="w-3 h-3" data-id="element-3191" /> {item.time}
                    </div>
                  </div>
                  <Link data-testid={`buyer-dashboard-activity-item-${i + 1}-action-btn`} to={item.link} className="text-xs font-bold border border-gray-300 px-3 py-1 bg-white hover:bg-gray-50" data-id="element-3192">
                    {item.action}
                  </Link>
                </div>)}
            </div>
          </div>

          <div data-testid="buyer-dashboard-recommended" className="bg-white border border-gray-300 p-6" data-id="element-3193">
            <div className="flex justify-between items-center mb-6" data-id="element-3194">
              <h3 className="font-bold text-lg" data-id="element-3195">Recommended for You</h3>
              <button data-testid="buyer-dashboard-edit-preferences-btn" onClick={handleEditPreferences} className="text-xs font-bold text-[#1f2933] hover:underline" data-id="element-3196">
                Edit Preferences
              </button>
            </div>
            <div className="space-y-4" data-id="element-3197">
              {[{
              title: 'Residential Plot in Wakad',
              price: '₹55 Lakhs',
              size: '1,800 Sq.ft'
            }, {
              title: 'Gated Community in Marunji',
              price: '₹42 Lakhs',
              size: '2,000 Sq.ft'
            }].map((plot, i) => <div key={i} data-testid={`buyer-dashboard-recommended-plot-${i + 1}`} className="border border-gray-200 p-4 hover:border-gray-400 transition-colors cursor-pointer group" data-id="element-3198">
                  <div className="flex justify-between mb-2" data-id="element-3199">
                    <h4 className="font-bold group-hover:text-blue-600 transition-colors" data-id="element-3200">
                      {plot.title}
                    </h4>
                    <span className="font-bold" data-id="element-3201">{plot.price}</span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-3202">
                    <span className="text-sm text-gray-500 font-mono" data-id="element-3203">
                      {plot.size}
                    </span>
                    <button data-testid={`buyer-dashboard-recommended-plot-${i + 1}-schedule-btn`} onClick={() => handleScheduleVisit(plot.title, 'Pune')} className="text-xs font-bold text-[#1f2933] flex items-center gap-1 hover:underline" data-id="element-3204">
                      Schedule Visit <ArrowRight className="w-3 h-3" data-id="element-3205" />
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {selectedPlot && <ScheduleVisitModal isOpen={isVisitModalOpen} onClose={() => setIsVisitModalOpen(false)} plotTitle={selectedPlot.title} location={selectedPlot.location} data-id="element-3206" />}

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={modalContent.title} message={modalContent.message} type="info" data-id="element-3207" />
    </DashboardLayout>;
}